import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import type { ApprovalInstance } from '@/types/approvals';

interface Props {
  row: ApprovalInstance;
  comments: string;
  acting: boolean;
  onCommentsChange: (value: string) => void;
  onAct: (action: string) => void;
}

export function ApprovalActionPanel({ row, comments, acting, onCommentsChange, onAct }: Props) {
  const canAct = row.canAct !== false;
  const isOpen = row.approvalStatus === 'PENDING' || row.approvalStatus === 'ESCALATED';
  const isReturned = row.approvalStatus === 'RETURNED';

  if (!canAct && !isReturned) return null;

  return (
    <div className="flex min-w-0 flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
      {canAct && isOpen ? (
        <>
          <Input
            placeholder="Comments (optional)"
            value={comments}
            onChange={(e) => onCommentsChange(e.target.value)}
            className="w-full min-w-[160px] sm:max-w-[200px]"
          />
          <div className="flex flex-wrap gap-1">
            <Button size="sm" disabled={acting} onClick={() => onAct('APPROVE')}>
              Approve
            </Button>
            <Button size="sm" variant="secondary" disabled={acting} onClick={() => onAct('REJECT')}>
              Reject
            </Button>
            <Button size="sm" variant="ghost" disabled={acting} onClick={() => onAct('RETURN')}>
              Return
            </Button>
          </div>
        </>
      ) : null}
      {isReturned ? (
        <Button size="sm" variant="secondary" disabled={acting} onClick={() => onAct('RESUBMIT')}>
          Resubmit
        </Button>
      ) : null}
    </div>
  );
}
